const prefix = '/INTERSTITIEL'

export const CLOSE_INTERSTITIEL = `${prefix}/CLOSE_INTERSTITIEL`
export const LOAD_INTERSTITIELS = `${prefix}/LOAD_INTERSTITIELS`
